import { FaultCategory, ResilienceFaults } from "../../__generated__/graphql-global-types";
export var percentageFieldFaults = [
    ResilienceFaults.packet_duplication,
    ResilienceFaults.packet_drop,
    ResilienceFaults.packet_corruption,
    ResilienceFaults.stress_cpu,
    ResilienceFaults.stress_disk,
    ResilienceFaults.stress_memory
];
export var stressorsFieldFaults = [ResilienceFaults.stress_io];
export var delayFieldFaults = [
    ResilienceFaults.network_delay,
    ResilienceFaults.network_delay_v2,
    ResilienceFaults.fixed_delay
];
export var sourcesFieldFaults = [ResilienceFaults.network_delay_v2];
export var timeoutFieldFaults = [
    ResilienceFaults.stress_memory,
    ResilienceFaults.stress_io,
    ResilienceFaults.stress_disk,
    ResilienceFaults.stress_cpu,
    ResilienceFaults.dns_blackhole,
    ResilienceFaults.aws_resource_blackhole,
    ResilienceFaults.generic_service_blackhole,
    ResilienceFaults.network_delay,
    ResilienceFaults.network_delay_v2,
    ResilienceFaults.packet_corruption,
    ResilienceFaults.packet_drop,
    ResilienceFaults.packet_duplication,
    ResilienceFaults.rds_az_failover,
    ResilienceFaults.redis_az_failover,
    ResilienceFaults.compute_az_failover,
    ResilienceFaults.custom_status_code,
    ResilienceFaults.custom_response,
    ResilienceFaults.fixed_delay,
    ResilienceFaults.az_failure
];
export var containerFieldFaults = [
    ResilienceFaults.stress_memory,
    ResilienceFaults.stress_io,
    ResilienceFaults.stress_disk,
    ResilienceFaults.stress_cpu,
    ResilienceFaults.dns_blackhole
];
export var blastRadiusFieldFaults = [
    ResilienceFaults.terminate_instances,
    ResilienceFaults.stress_cpu,
    ResilienceFaults.stress_disk,
    ResilienceFaults.stress_io,
    ResilienceFaults.stress_memory,
    ResilienceFaults.network_delay,
    ResilienceFaults.network_delay_v2,
    ResilienceFaults.packet_corruption,
    ResilienceFaults.packet_drop,
    ResilienceFaults.packet_duplication
];
export var microsGroupsFieldFaults = [
    ResilienceFaults.terminate_instances,
    ResilienceFaults.stress_cpu,
    ResilienceFaults.stress_disk,
    ResilienceFaults.stress_io,
    ResilienceFaults.stress_memory,
    ResilienceFaults.network_delay,
    ResilienceFaults.network_delay_v2,
    ResilienceFaults.packet_corruption,
    ResilienceFaults.packet_drop,
    ResilienceFaults.packet_duplication,
    ResilienceFaults.dns_blackhole
];
export var targetDnsFieldFaults = [ResilienceFaults.dns_blackhole];
export var targetServiceDropDownFieldFaults = [
    ResilienceFaults.aws_resource_blackhole
];
export var targetServiceTextFieldFaults = [
    ResilienceFaults.generic_service_blackhole
];
export var targetRegionDropDownFieldFaults = [
    ResilienceFaults.aws_resource_blackhole
];
export var resourceNameFieldFaults = [
    ResilienceFaults.rds_az_failover,
    ResilienceFaults.redis_az_failover
];
export var removeAZFieldFaults = [ResilienceFaults.compute_az_failover];
export var targetAZFieldFaults = [ResilienceFaults.az_failure];
export var rdsNameFieldFaults = [ResilienceFaults.reboot_rds];
export var methodFieldFaults = [
    ResilienceFaults.fixed_delay,
    ResilienceFaults.malformed_response_chunk,
    ResilienceFaults.empty_response,
    ResilienceFaults.random_data_then_close,
    ResilienceFaults.connection_reset_by_peer,
    ResilienceFaults.custom_status_code
];
export var urlFieldFaults = [
    ResilienceFaults.fixed_delay,
    ResilienceFaults.malformed_response_chunk,
    ResilienceFaults.empty_response,
    ResilienceFaults.random_data_then_close,
    ResilienceFaults.connection_reset_by_peer,
    ResilienceFaults.custom_status_code
];
export var statusFieldFaults = [
    ResilienceFaults.fixed_delay,
    ResilienceFaults.custom_status_code
];
export var bodyFieldFaults = [
    ResilienceFaults.fixed_delay,
    ResilienceFaults.custom_status_code
];
export var wiremockArgumentsFieldFaults = [ResilienceFaults.custom_response];
export var CATEGORY_FAULTS_MAPPING = new Map([
    [
        FaultCategory.aws,
        [ResilienceFaults.terminate_instances, ResilienceFaults.reboot_rds]
        /*Commenting out the below line as we don't want to release the fault in UI now
        [
          ResilienceFaults.terminate_instances,
          ResilienceFaults.reboot_rds,
          ResilienceFaults.az_failure
        ]*/
    ],
    [
        FaultCategory.stress,
        [
            ResilienceFaults.stress_cpu,
            ResilienceFaults.stress_disk,
            ResilienceFaults.stress_io,
            ResilienceFaults.stress_memory
        ]
    ],
    [
        FaultCategory.network,
        [
            ResilienceFaults.network_delay,
            ResilienceFaults.network_delay_v2,
            ResilienceFaults.packet_corruption,
            ResilienceFaults.packet_drop,
            ResilienceFaults.packet_duplication
        ]
    ],
    [
        FaultCategory.blackhole,
        [
            ResilienceFaults.dns_blackhole,
            ResilienceFaults.aws_resource_blackhole,
            ResilienceFaults.generic_service_blackhole
        ]
    ],
    [
        FaultCategory.az_failover,
        [
            ResilienceFaults.rds_az_failover,
            ResilienceFaults.redis_az_failover,
            ResilienceFaults.compute_az_failover
        ]
    ],
    [
        FaultCategory.application_layer,
        [
            ResilienceFaults.fixed_delay,
            ResilienceFaults.custom_status_code,
            ResilienceFaults.custom_response
        ]
    ]
]);
export var supportedAWSResourcesForBlackhole = ["S3", "DYNAMODB"];
export var supportedAWSRegionsForBlackhole = [
    "us-east-1",
    "us-west-1",
    "us-west-2",
    "ca-central-1",
    "eu-west-1",
    "eu-central-1",
    "eu-central-2",
    "ap-southeast-1",
    "ap-southeast-2"
];
